




















































import { Vue, Component, Prop } from 'vue-property-decorator';

import InputError from '~/components/inputs/InputError.vue';

@Component({
  components: { InputError },
})
export default class CheckInput extends Vue {
  @Prop(Boolean) value: false;
  @Prop(Object) v: () => ({});
  @Prop(Object) vMessages: () => ({});
  @Prop(String) label: '';

  $refs: {
    inputEl: HTMLInputElement
  };

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }
}
